export { setNonce } from '@stencil/core';
import { bootstrapLazy } from '@stencil/core';
import { globalScripts } from '@stencil/core/internal/app-globals';
export const defineCustomElements = async (win, options) => {
  if (typeof window === 'undefined') return undefined;
  await globalScripts();
  return bootstrapLazy([/*!__STENCIL_LAZY_DATA__*/], options);
};
